import { Box, Typography, Card, CardContent, CardMedia, Stack, Rating, Button, Paper, Select, MenuItem, FormControl, InputLabel, IconButton } from "@mui/material";
import { motion } from "framer-motion";
import AOS from "aos";
import Grid from '@mui/material/GridLegacy'
import "aos/dist/aos.css";
import StarBorderIcon from '@mui/icons-material/StarBorder';
import mentorbot from '../assets/image/mentoringbottom.png'
import dev from '../assets/image/mentor1.jpg';
import kenny from '../assets/image/mentor2.jpg';
import pratham from '../assets/image/mentor3.jpg';
import { useEffect, useState } from "react";
import RightSwipeableDrawer from "../component/drawer";
import { getCountryData, getMentorData } from "../services";
import Slider from "../component/slider";
import SearchIcon from '@mui/icons-material/Search';
import { useNavigate } from "react-router-dom";
const ITEMS_PER_PAGE = 4;
const MeetOurMentor = () => {
  const [visibleCount, setVisibleCount] = useState(8); // Initial cards to show
  const [openDrawer, setOpenDrawer] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const [MentosData, setMentosData] = useState([]);
  const [CountryData, setCountryData] = useState([]);
  const [FilterCountry, setFilterCountry] = useState("");
  const navigate = useNavigate();
  const handleOpenDrawer = (item) => {

    setSelectedItem(item);  // Store clicked card data
    setOpenDrawer(true);    // Open the drawer
  };
  const handleLoadMore = () => {
    setVisibleCount((prev) => prev + ITEMS_PER_PAGE);
  };
  async function Mentorlist(data) {
    try {
      const result = await getMentorData(data, 1);
      setMentosData(result.data);
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  }
  async function Countrylist() {
    try {
      const result = await getCountryData();
      setCountryData(result.data);
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  }
  useEffect(() => {
    AOS.init({
      duration: 1000,
      once: true,
    });
    Mentorlist();
    Countrylist();
  }, []);
  const handleChange = (event) => {
    setFilterCountry(event.target.value);
  };
  const Searchlist = (data) => {
    data === "Worldwide" ? Mentorlist() : Mentorlist(data);
  };
  return (
    <>
      <Grid
        container
        spacing={4}
        sx={{
          backgroundColor: "#93b1b5",
          overflow: "hidden",
          paddingTop: {
            xs: "100px",
            sm: "120px",
          },
        }}
      >
        <Grid item xs={12} sm={8} md={7} mt={4} mb={4}>
          <Box
            display="flex"
            height="100%"
            alignItems="center"
            justifyContent="center"
            sx={{ minHeight: { xs: 'auto', sm: '300px' }, paddingLeft: { xs: '0px', sm: '30px' } }}
          >
            <motion.div
              initial={{ y: "-100vh", opacity: 0 }}
              animate={{ y: 0, opacity: 1 }}
              transition={{ duration: 1.8, ease: "easeOut" }}
            >
              <Typography data-aos="fade-down" variant="h1" mb={6} sx={{
                fontFamily: "Poppins, sans-serif",
                fontWeight: 600,
                lineHeight: "1.2",
                fontSize: {
                  xs: "2rem",
                  sm: "1rem",
                  md: "1.4rem",
                  lg: "1.4rem",
                  xl: "3.5rem",
                },
              }}>Global Expert. Real Advice</Typography>
              <Typography data-aos="fade-right"
                variant="h5"
                sx={{
                  fontFamily: "Poppins, sans-serif",
                  fontWeight: 700,
                  lineHeight: "1.2",
                  color: "grey",
                  fontSize: {
                    xs: "1.7rem",
                    sm: "1rem",
                    md: "1.4rem",
                    lg: "1.4rem",
                    xl: "2.5rem",
                  },
                }}
              >
                OUR MENTORS{" "}
                <Box
                  component="span"
                  sx={{
                    color: "#2B4F60",
                    fontWeight: 500,
                    fontSize: {
                      xs: "1rem",
                      sm: "1rem",
                      md: "1.4rem",
                      lg: "1.4rem",
                      xl: "2rem",
                    },
                  }}
                >
                  have studied abroad successfully and are here to guide you. Get real
                  insights on applications, scholarships, jobs, and adapting to new
                  cultures.
                </Box>
              </Typography>
            </motion.div>
          </Box>
        </Grid>

        {/* Right Side: Slider with vertical spacing */}
        <Grid
          item
          xs={12}
          mt={7} mb={7}
          sm={4}
          md={4}
          sx={{
            pt: { xs: 2, sm: 4 }, // Top padding
            pb: { xs: 2, sm: 4 }, // Bottom padding
            paddingLeft: {
              xs: "15px",
              sm: "0px",
              md: "0px",
              lg: "0px",
              xl: "0px",
            },
            marginRight: {
              xs: "15px",
              sm: "0px",
              md: "0px",
              lg: "0px",
              xl: "0px",
            },
            marginLeft: {
              xs: "15px",
              sm: "0px",
              md: "0px",
              lg: "0px",
              xl: "0px",
            },
          }}
        >
          <Slider image1={dev} image2={kenny} image3={pratham} />
        </Grid>
      </Grid>



      <Box sx={{ textAlign: "center", margin: "auto", padding: "40px 20px" }}>
        <Typography data-aos="fade-up" variant="h3" fontWeight="500" color="#2B4F60" fontFamily="Poppins, sans-serif" sx={{
          mb: "40px", fontSize: {
            xs: "2.2rem",
            sm: "3rem",
            md: "2.7rem",
            lg: "3.1rem",
            xl: "3.5rem",
          },
        }}>
          Meet Our <span style={{ color: "#23a8e1" }}>Mentors</span>
        </Typography>
        <Typography data-aos="fade-down" variant="body1" fontWeight="500" color="#2B4F60" fontFamily="Poppins, sans-serif" sx={{
          fontSize: {
            xs: "1rem",
            sm: "1.4rem",
            md: "1.5rem",
            lg: "1.1rem",
            xl: "1.5rem",
          },
          color: "black",
          margin: '0 auto',
          fontFamily: "Poppins, sans-serif", fontWeight: {
            xl: "350",
            lg: "400",
            sm: "300",
            xs: "350",
            md: "400" // Adjust for medium screens
          }, lineHeight: {
            xl: "2.5rem",
            lg: "2.3rem",
            sm: "2.3rem",
            xs: "1.7rem",
            md: "2.4rem" // Adjust for medium screens
          }, paddingBottom: "50px"
          // Center the text block
          // maxWidth: 'auto' // Limit width for better readability
        }}>
          Studying abroad can be challenging, but you don’t have to do it alone. Our mentors are students who have successfully navigated the process and are here to share their firsthand experiences. From choosing the right university to securing scholarships and adjusting to a new culture, they provide honest, practical advice tailored to your needs. Get guidance from those who have been in your position and make informed decisions with confidence!
        </Typography>
      </Box>

      <Box sx={{ padding: "69px", backgroundColor: "aliceblue" }}>
        <Box
          sx={{
            display: "flex",
            justifyContent: "flex-end",
            alignItems: "center",
            mb: 3,
            gap: 1, // spacing between select and icon
          }}
        >
          <FormControl sx={{
            minWidth: {
              xs: '80%',  // Small screens
              sm: '60%',  // ≥600px
              md: '40%',  // ≥900px
            },
          }}>
            <InputLabel id="age-select-label">Select Country</InputLabel>
            <Select
              labelId="age-select-label"
              label="Select Country"
              value={FilterCountry}
              onChange={handleChange} // ✅ attach here
              sx={{
                height: 50,
                bgcolor: "#f0f8ff",
                '& .MuiOutlinedInput-notchedOutline': {
                  borderColor: '#90caf9',
                  borderWidth: '2px',
                },
                '&:hover .MuiOutlinedInput-notchedOutline': {
                  borderColor: '#1976d2',
                },
                '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                  borderColor: '#1976d2',
                },
              }}
              MenuProps={{
                PaperProps: {
                  sx: {
                    background: "linear-gradient(135deg, #c3ecff, #a0d2eb)",
                    color: "#0d47a1",
                    borderBottomRightRadius: "10px",
                  },
                },
              }}
            >
              {[...CountryData, "Worldwide"].map((item, index) => (
                <MenuItem key={index} value={item}>
                  {item}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          <IconButton
            sx={{
              height: 50,
              width: 40,
              backgroundColor: "#e3f2fd",
              border: "2px solid #90caf9",
              borderRadius: "8px",
              color: "#1976d2",
              '&:hover': {
                backgroundColor: "#bbdefb",
              },
            }}
          >
            <SearchIcon onClick={() => Searchlist(FilterCountry)} />
          </IconButton>
        </Box>
        <Grid container spacing={6} overflow="hidden" sx={{ display: "flex", justifyContent: "center" }}>
          {MentosData.slice(0, visibleCount).map((item, index) => (
            <Grid item key={index} xs={12} sm={6} md={4} xl={3}>
              <Card
                sx={{
                  textAlign: "center",
                  background: "linear-gradient(135deg, #e0f7fa, #80deea)",
                  borderRadius: "15px",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "space-between",
                  width: "100%",  // ✅ Equal width cards
                  height: "100%", // ✅ Equal height cards
                  flexGrow: 1,    // ✅ Sab cards equal size le
                }}
                onClick={() => handleOpenDrawer(item)}
              >
                <CardMedia
                  component="img"
                  image={item?.profile}
                  alt={item.name}
                  sx={{
                    width: "100px",
                    height: "100px",
                    borderRadius: "50%",
                    display: "block",
                    margin: "0 auto",
                    border: "6px solid white",
                    objectFit: "cover",   // ✅ shows full image without cropping
                    // backgroundColor: "#fff" // ✅ fallback background
                  }}
                />

                <CardContent
                  sx={{
                    flexGrow: 1, // ✅ Equal height maintain karega
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                  }}
                >
                  <Stack sx={{ alignItems: "center" }} spacing={1}>
                    <Rating name="read-only" emptyIcon={<StarBorderIcon style={{ color: 'gold' }} />} value={item.rating} readOnly />
                    <Typography variant="h5" sx={{
                      fontFamily: "Poppins, sans-serif",
                      fontWeight: "400",
                      fontSize: { xs: "2.2rem", sm: "1.7rem", md: "1.9rem", lg: "1.5rem", xl: "2rem" }
                    }}>
                      {item.name}
                    </Typography>
                    <Typography variant="body1" sx={{
                      fontFamily: "Poppins, sans-serif",
                      fontWeight: "500",
                      fontSize: { xs: "1.5rem", sm: "1rem", md: "1.2rem", lg: "1.2rem", xl: "1.5rem" }
                    }} color="text.secondary">
                      {item.college != "null" ? item.college : ''}
                    </Typography>
                    <Typography variant="body2" sx={{
                      fontFamily: "Poppins, sans-serif",
                      fontWeight: "300",
                      fontSize: { xs: "1.7rem", sm: "1.2rem", md: "1.5rem", lg: "1.4rem", xl: "1.2rem" }
                    }}>
                      {item.expertise != "null" ? item.expertise : ''}
                    </Typography>
                  </Stack>
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>

        {/* Show "Load More" button only if there are more items to display */}
        {visibleCount < MentosData.length && (
          <Box sx={{ display: "flex", justifyContent: "center", mt: 4 }}>
            <Button variant="contained" onClick={handleLoadMore}>Load More</Button>
          </Box>
        )}
      </Box>
      <Grid container spacing={4} justifyContent="center" alignItems="center" paddingTop="60px" paddingBottom="60px">
        {/* Left Content Box */}
        <Grid item overflow="hidden" xs={12} md={4} sx={{marginRight: {
              xs: "15px",
              sm: "0px",
              md: "0px",
              lg: "0px",
              xl: "0px",
            },
            marginLeft: {
              xs: "15px",
              sm: "0px",
              md: "0px",
              lg: "0px",
              xl: "0px",
            },}}>
          <CardMedia data-aos="zoom-in" component='img' image={mentorbot} sx={{ borderRadius: "15px", width: "100%", 
             }} />
        </Grid>
        <Grid item overflow="hidden" xs={12} md={6}>
          <Paper data-aos="zoom-in"

            sx={{
              padding: 4,
              backgroundColor: "#f5f5f5",
              borderRadius: 2,
              textAlign: "center",
            }}
          >
            <Typography variant="h4" fontWeight="500" fontFamily="Poppins, sans-serif" color="#2B4F60" gutterBottom>
              Have Questions? We’re Here to Help!

            </Typography>

            {/* Colored Line */}
            <Box
              sx={{
                height: 5,
                width: "80px",
                background: "linear-gradient(to right, #9BCB3D, #2E5DAC, #58A8F8)",
                margin: "auto",
                marginBottom: 2,
              }}
            ></Box>

            <Typography variant="body1" fontWeight="400" fontFamily="Poppins, sans-serif" color="#23a8e1" paragraph>
              Planning to study abroad but feeling overwhelmed? Our mentors are here to guide you every step of the way. Whether you need advice on applications, scholarships, visas, or settling into a new country, we've got you covered. Browse our FAQs or reach out directly to get personalized support from experienced students.
            </Typography>

            <Button
              variant="contained"
              sx={{
                backgroundColor: "#2B4F60",
                color: "white",
                padding: "10px 20px",
                "&:hover": { backgroundColor: "#333" },
              }}
              onClick={() => navigate("/query")}
            >
              Contact us
            </Button>
          </Paper>
        </Grid>

        {/* Right Image Box */}

      </Grid>
      <RightSwipeableDrawer open={openDrawer} setOpen={setOpenDrawer} data={selectedItem} />
    </>

  )
}



export default MeetOurMentor; 